import { LineChartData } from '../../pages/Chat/Chat/types';

export const groupLineDataByKey = (data: LineChartData[]) => {
    return data.reduce((acc: Record<string, unknown[]>, obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            acc[key] = acc[key] || [];
            acc[key].push(value);
        });
        return acc;
    }, {} as Record<string, unknown[]>);
};
